import { useState } from "react";
import { createModel } from "hox";
import { useSessionStorageState } from "ahooks";
import { useGlobalModel } from "@/model/globalModel";
import { dictService } from "@/views/base/dict/dictService";

export enum DetailActionTypeEnum {
    STATEMENT,
    BILL
}

type labelsType = {
    [proppName: string]: string;
}
export const useDetailModel = createModel(function () {
    const { user } = useGlobalModel();
    const [actionType, setActionType] = useSessionStorageState<number>("contract.detail.type", DetailActionTypeEnum.STATEMENT) // 选中展示模块

    const [customerCode, setCustomerCode] = useSessionStorageState<string>("contract.detail.customerCode", "");
    const [title, setTitle] = useSessionStorageState<string>("contract.detail.title", "");

    //数据字典解析
    const [dictLabels, setDictLabels] = useState<labelsType>({});

    const loadLabel = () => {
        dictService.dictItemDs("settle-type").then(ds => {
            let obj: labelsType = {}
            ds.forEach(item => {
                obj[item.value] = item.label
            })
            setDictLabels({ ...dictLabels, ...obj })
        })
    }


    return {
        user,
        actionType, setActionType,
        title, setTitle,
        customerCode, setCustomerCode,
        dictLabels, loadLabel,
    }
});
